import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  // IconButton,
  // InputAdornment,
  // TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as yup from "yup";
import { AxiosResponse } from "axios";
import {
  CommonDrawerStyle,
  DrawerForm,
  DrawerHeader,
} from "../../Common/styles/drawer";
import { errorToastMessage, toastMessage } from "../../../utils/toast";
import http from "../../../utils/http";
import { InputWrapper } from "../../Common/styles/form";
import { ModalDrawerButtonStyles } from "../../Common/styles/modal";
import { setStateToggle } from "../../../Redux/reducers/studySlice";
import { useAppDispatch } from "../../../Redux/hooks";
// import { CloseRounded } from "@mui/icons-material";
// import { debounce } from "lodash";
// import { v4 as uuid } from "uuid";
// import { GridSearchIcon } from "@mui/x-data-grid";

type Props = {
  closeDrawer: () => void;
  refreshPage: () => void;
  selectedLanguages: any[];
  canEdit: boolean;
  studyId?: string;
};
type FormValues = {
  languages: string[];
};

const schema = yup.object().shape({
  languages: yup.array().of(yup.string().nullable()).nullable(),
});

const AddLanguagesDrawer: React.FC<Props> = ({
  closeDrawer,
  refreshPage,
  selectedLanguages,
  canEdit,
  studyId,
}) => {
  const dispatch = useAppDispatch();

  const [submitLoader, setSubmitLoader] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [languages, setLanguages] = useState<any[]>([]);
  // const [searchText, setSearchText] = useState("");
  // const [searchId, setSearchId] = useState(uuid());

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const url: string = `/data/languages`;
        // let url: string;
        // if (studyId) {
        //   url = `/data/languages`;
        // } else {
        //   url = `/registry/data/languages`;
        // }
        const res: AxiosResponse = await http.get(url);
        const resData = res?.data?.data;
        const languageOptions = resData.map((lang: any) => ({
          code: lang.code,
          label: lang.label,
        }));
        const filteredLanguages = languageOptions.filter(
          (lang: any) =>
            !selectedLanguages.some(
              (selected) => selected.languageCode === lang.code
            )
        );
        setLanguages(filteredLanguages || []);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        errorToastMessage(err as Error);
      }
    };
    fetchData();
  }, [selectedLanguages, setLoading, studyId]);

  async function submitHandler(values: any) {
    try {
      setSubmitLoader(true);
      let body = {
        languageCodes: [...values.languages],
      };
      let res: AxiosResponse;
      if (studyId) {
        res = await http.post(`/study/${studyId}/settings/languages`, body);
      } else {
        res = await http.post(`/admin/registry/settings/languages`, body);
      }
      toastMessage("success", res.data.message);
      closeDrawer();
      refreshPage();
      dispatch(setStateToggle());
      setSubmitLoader(false);
    } catch (err) {
      errorToastMessage(err as Error);
      setSubmitLoader(false);
    }
  }

  // const modifySearchTerm = useMemo(
  //   () =>
  //     debounce((val) => {
  //       setSearchText(val);
  //     }, 500),
  //   [setSearchText]
  // );
  // const handleClearSearch = () => {
  //   setSearchText("");
  //   setSearchId(uuid());
  // };
  return (
    <Box sx={{ ...CommonDrawerStyle, height: "calc(100vh - 124px)" }}>
      <DrawerHeader closeDrawer={closeDrawer} title={"Select Languages"} />
      {/* <Box
        sx={{
          height: "64px",
          display: "flex",
          alignItems: "center",
          mb: 2,
        }}
      >
        <TextField
          key={searchId}
          placeholder="Search for Languages"
          style={{ width: "100%" }}
          defaultValue={searchText}
          onChange={(e) => modifySearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <GridSearchIcon />
              </InputAdornment>
            ),
            endAdornment: searchText && (
              <InputAdornment position="end">
                <IconButton onClick={handleClearSearch}>
                  <CloseRounded />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box> */}

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
          <CircularProgress size={25} />
        </Box>
      ) : (
        <Formik<FormValues>
          initialValues={{
            languages: [],
          }}
          enableReinitialize
          onSubmit={(values: any) => {
            submitHandler(values);
          }}
          validationSchema={schema}
        >
          {({ values, setFieldValue }) => (
            <Form style={{ height: "100%" }}>
              {languages.length > 0 ? (
                <>
                  <Box sx={DrawerForm}>
                    {languages?.map((language) => (
                      <FormControl key={language.code} sx={InputWrapper}>
                        <FormControlLabel
                          label={
                            <Typography
                              variant="subtitle1"
                              fontWeight={"regular"}
                              color="text.primary"
                            >
                              {language.label}
                            </Typography>
                          }
                          control={
                            <Checkbox
                              checked={values.languages.includes(language.code)}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFieldValue("languages", [
                                    ...values.languages,
                                    language.code,
                                  ]);
                                } else {
                                  setFieldValue(
                                    "languages",
                                    values.languages.filter(
                                      (code: any) => code !== language.code
                                    )
                                  );
                                }
                              }}
                            />
                          }
                        />
                      </FormControl>
                    ))}
                  </Box>

                  {canEdit && (
                    <Box sx={{ mt: "auto" }}>
                      <Divider />
                      <Box sx={ModalDrawerButtonStyles}>
                        {!submitLoader ? (
                          <>
                            <Button onClick={closeDrawer} variant="outlined">
                              Cancel
                            </Button>
                            <Button type="submit" variant="contained">
                              Apply
                            </Button>
                          </>
                        ) : (
                          <CircularProgress size={25} />
                        )}
                      </Box>
                    </Box>
                  )}
                </>
              ) : (
                <Typography
                  variant="subtitle1"
                  fontWeight={"regular"}
                  color="text.primary"
                  textAlign="center"
                >
                  No languages available
                </Typography>
              )}
            </Form>
          )}
        </Formik>
      )}
    </Box>
  );
};

export default AddLanguagesDrawer;
